import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { PieChart as PieIcon } from "lucide-react";
import { Card } from "@/components/ui/card";
import { CLP } from "@/lib/format";

const COLORS = { basico: "#C4B5FD", creador: "#8B5CF6", pro: "#5B21B6" };
const pct = (n) => `${String(n).replace(".", ",")}%`;

const Tip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload;
  return (
    <div className="rounded-lg border bg-popover px-3 py-2 text-xs shadow-md">
      <p className="font-semibold">{d.name}</p>
      <p>{d.count} compra{d.count === 1 ? "" : "s"} · {pct(d.pct)}</p>
      <p className="text-muted-foreground">{CLP(d.amount_clp)}</p>
    </div>
  );
};

export function FichasPie({ packs, total, orders }) {
  const data = packs.filter((p) => p.count > 0);
  return (
    <Card className="p-5 sm:col-span-2 lg:col-span-3" data-testid="admin-fichas-pie">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <h3 className="font-bold flex items-center gap-2"><PieIcon className="w-5 h-5 text-primary" />Monto pagado por Fichas</h3>
        <p className="text-sm text-muted-foreground"><span className="font-display font-extrabold text-2xl text-foreground" data-testid="admin-fichas-total">{CLP(total)}</span> · {orders} compra{orders === 1 ? "" : "s"} · IVA incluido</p>
      </div>
      {data.length === 0 ? (
        <p className="py-10 text-center text-sm text-muted-foreground" data-testid="admin-fichas-empty">Aún no hay compras de Fichas.</p>
      ) : (
        <div className="mt-4 grid md:grid-cols-[260px_1fr] items-center gap-6">
          <div className="h-56">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie data={data} dataKey="count" nameKey="name" innerRadius={55} outerRadius={95} paddingAngle={2} stroke="none">
                  {data.map((d) => <Cell key={d.id} fill={COLORS[d.id] || "#8B5CF6"} />)}
                </Pie>
                <Tooltip content={<Tip />} />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="space-y-2">
            {packs.map((p) => (
              <div key={p.id} className="flex items-center gap-3 rounded-xl border border-border px-4 py-3" data-testid={`admin-pack-${p.id}`}>
                <span className="w-3 h-3 rounded-full shrink-0" style={{ background: COLORS[p.id] }} />
                <span className="flex-1 font-semibold">{p.name}</span>
                <span className="text-sm tabular-nums">{p.count} compra{p.count === 1 ? "" : "s"}</span>
                <span className="w-16 text-right text-sm font-bold text-primary tabular-nums" data-testid={`admin-pack-pct-${p.id}`}>{pct(p.pct)}</span>
                <span className="hidden sm:block w-24 text-right text-sm text-muted-foreground tabular-nums">{CLP(p.amount_clp)}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </Card>
  );
}
